import { useActiveJob } from '../../hooks/active-job.hook';
import { JobEditTitle } from '../titles/JobEditTitle';

export const JobEditPageNav = (): React.ReactElement<any, any> | null => {
    const { job } = useActiveJob();

    return <JobEditTitle job={job} />;
};
